const Event = {
  'LoginSuccess': 'onSuccess'
}
export default Event



// WEBPACK FOOTER //
// ./src/const/Event.js